const getters={
    app:state=>state.app,
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js